import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

/**
 * Card shell used by every widget: title, optional subtitle, optional action (top right).
 * Set `flush` for tables so they run edge to edge.
 */
export default function DashboardCard({ title, subtitle, action, flush = false, children, sx }) {
  return (
    <Paper
      elevation={1}
      sx={{ borderRadius: 3, py: 2.5, px: flush ? 0 : 3, display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0, ...sx }}
    >
      <Stack direction="row" sx={{ flexWrap: 'wrap', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, px: flush ? 3 : 0 }}>
        <Box>
          <Typography variant="h6" component="h2" sx={{ fontSize: 18, fontWeight: 500 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        {action}
      </Stack>
      {children}
    </Paper>
  );
}

export function EmptyState({ children = 'No data for these filters' }) {
  return (
    <Typography variant="body2" color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
      {children}
    </Typography>
  );
}
